const RETURN_URL = 'returnUrl';

export function openSubapp(path: string) {
    // Remove search params from the path. Otherwise create agreement via URL will return to same url and try to create new agreement
    sessionStorage[RETURN_URL] = `${window.location.origin}${window.location.pathname}`;
    window.location.href = path;
}
